import getDataSelector from 'core/utils/getDataSelector'
import DataKeys from 'k8s/DataKeys'

export const regionsSelector = getDataSelector<DataKeys.Regions>(DataKeys.Regions)
